"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const heading_module_scss_1 = __importDefault(require("./heading.module.scss"));
exports.spacings = ['xs', 'sm', 'md', 'lg'];
const Heading = ({ as: Component = 'h1', fontSize = 'md', color = 'grey-gray', spacing = 'md', withUnderline = false, fontWeight = 'medium', align = 'left', italic = false, className, children, }) => {
    return ((0, jsx_runtime_1.jsx)(Component, { className: (0, classnames_1.default)(className, heading_module_scss_1.default.heading, heading_module_scss_1.default[`size_${fontSize}`], heading_module_scss_1.default[`spacing_${spacing}`], heading_module_scss_1.default[`weight_${fontWeight}`], heading_module_scss_1.default[color], withUnderline && heading_module_scss_1.default.withUnderline, align !== 'left' && heading_module_scss_1.default[`align_${align}`], italic && heading_module_scss_1.default.italic), children: children }));
};
exports.default = Heading;
